<template>
  <FooterLayout :nologo="nologo">
    <template v-slot:logo>
      <BorderlessButton href="/">
        <Logo/>
      </BorderlessButton>
    </template>
    <template v-slot:contacts>
      <template v-for="item in contacts">
        <template v-if="item.href">
          <BorderlessButton :href="item.href" :key="item.icon">
            <IconText :icon="item.icon" :text="item.text"/>
          </BorderlessButton>
        </template>
        <template v-else>
          <IconText :key="item.icon" :icon="item.icon" :text="item.text"/>
        </template>
      </template>
    </template>
    <template v-slot:nav>
      <template v-for="item in menuItems">
        <BorderlessButton :key="item.to" :href="item.to">{{$t(item.name)}}</BorderlessButton>
      </template>
      <BorderlessButton disabled>FAQ</BorderlessButton>
    </template>
  </FooterLayout>
</template>

<script>
import contacts from "@/cfg/contacts";
import menuItems from "@/cfg/menuItems";

import BorderlessButton from "@/components/BorderlessButton";
import FooterLayout from "@/components/FooterLayout";
import IconText from "@/components/IconText";
import Logo from "@/components/Logo";

export default {
  name: 'Footer',
  components: {
    FooterLayout,
    BorderlessButton,
    IconText,
    Logo,
  },
  props: {
    nologo: Boolean,
  },
  data() {
    return {
      contacts: contacts,
      menuItems: menuItems,
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
